<template>
    <div id="content" class="content animated slideInRight delay-1s">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Logs do Sistema</h3>
                        <div class="card-tools">
                            <div class="input-group input-group-sm" style="width: 250px;">
                                <input type="text" v-model="searchQuery" class="form-control float-right" placeholder="Buscar...">
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-default">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Data/Hora</th>
                                        <th>Nível</th>
                                        <th>Mensagem</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(error, index) in groupedErrors" >
                                        <tr class="error-row" @click="toggleError(index)">
                                            <td>{{ formatDate(error.firstLine) }}</td>
                                            <td>
                                                <span :class="getLogLevelClass(error.firstLine)">
                                                    {{ getLogLevel(error.firstLine) }}
                                                </span>
                                            </td>
                                            <td>{{ getLogMessage(error.firstLine) }}</td>
                                            <td>
                                                <i class="fas" :class="expandedErrors[index] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                            </td>
                                        </tr>
                                        <tr v-if="expandedErrors[index]" class="stacktrace-row">
                                            <td colspan="4">
                                                <pre class="stacktrace">{{ error.stacktrace }}</pre>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer clearfix">
                        <div class="float-left">
                            <button class="btn btn-danger" @click="clearLogs" :disabled="loading">
                                <i class="fas fa-trash"></i> Limpar Logs
                            </button>
                        </div>
                        <div class="float-right">
                            <div class="btn-group">
                                <button class="btn btn-default" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <button class="btn btn-default" disabled>
                                    Página {{ currentPage }} de {{ totalPages }}
                                </button>
                                <button class="btn btn-default" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                            <button class="btn btn-primary ml-2" @click="refreshLogs" :disabled="loading">
                                <i class="fas fa-sync" :class="{ 'fa-spin': loading }"></i> Atualizar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { fetchGet, fetchPost } from '@/composables/api';

export default {
    name: 'Log',
    data() {
        return {
            logs: [],
            searchQuery: '',
            loading: false,
            expandedErrors: {},
            currentPage: 1,
            totalPages: 1
        }
    },
    computed: {
        filteredLogs() {
            if (!this.searchQuery) return this.logs;
            const query = this.searchQuery.toLowerCase();
            return this.logs.filter(log =>
                log.toLowerCase().includes(query)
            );
        },
        groupedErrors() {
            const errors = [];
            let currentError = null;

            this.filteredLogs.forEach(log => {
                if (this.isErrorStart(log)) {
                    if (currentError) {
                        errors.push(currentError);
                    }
                    currentError = {
                        firstLine: log,
                        stacktrace: ''
                    };
                } else if (currentError) {
                    currentError.stacktrace += log + '\n';
                }
            });

            if (currentError) {
                errors.push(currentError);
            }

            return errors;
        }
    },
    methods: {
        async refreshLogs() {
            this.loading = true;
            try {
                const response = await fetchGet(`logs?page=${this.currentPage}`);
                this.logs = response.data.logs.split('\n').filter(line => line.trim());
                this.totalPages = response.data.pagination.total_pages;
            } catch (error) {
                console.error('Erro ao carregar logs:', error);
            } finally {
                this.loading = false;
            }
        },
        async clearLogs() {
            if (!confirm('Tem certeza que deseja limpar os logs? Um backup será criado automaticamente.')) {
                return;
            }

            this.loading = true;
            try {
                const response = await fetchPost('logs/clear');
                alert('Logs limpos com sucesso!');
                this.refreshLogs();
            } catch (error) {
                console.error('Erro ao limpar logs:', error);
                alert('Erro ao limpar logs: ' + error.message);
            } finally {
                this.loading = false;
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
                this.refreshLogs();
            }
        },
        formatDate(log) {
            const dateMatch = log.match(/\[(.*?)\]/);
            return dateMatch ? dateMatch[1] : 'N/A';
        },
        getLogLevel(log) {
            if (log.includes('ERROR')) return 'ERROR';
            if (log.includes('WARNING')) return 'WARNING';
            if (log.includes('INFO')) return 'INFO';
            if (log.includes('DEBUG')) return 'DEBUG';
            return 'UNKNOWN';
        },
        getLogLevelClass(log) {
            const level = this.getLogLevel(log);
            return {
                'badge': true,
                'badge-danger': level === 'ERROR',
                'badge-warning': level === 'WARNING',
                'badge-info': level === 'INFO',
                'badge-secondary': level === 'DEBUG',
                'badge-dark': level === 'UNKNOWN'
            };
        },
        getLogMessage(log) {
            const messageMatch = log.match(/\]\s*(.*)/);
            return messageMatch ? messageMatch[1] : log;
        },
        isErrorStart(log) {
            return log.includes('ERROR') || log.includes('Exception') || log.includes('Fatal error');
        },
        toggleError(index) {
            this.$set(this.expandedErrors, index, !this.expandedErrors[index]);
        }
    },
    mounted() {
        this.refreshLogs();
    }
}
</script>

<style scoped>
.card {
    box-shadow: 0 0 1px rgba(0,0,0,.125), 0 1px 3px rgba(0,0,0,.2);
    margin-bottom: 1rem;
}

.card-header {
    background-color: rgba(0,0,0,.03);
    border-bottom: 1px solid rgba(0,0,0,.125);
    padding: 0.75rem 1.25rem;
}

.card-title {
    margin: 0;
    color: #495057;
    font-size: 1.1rem;
    font-weight: 600;
}

.table-responsive {
    min-height: 300px;
    max-height: 600px;
    overflow-y: auto;
}

.badge {
    padding: 0.35em 0.65em;
    font-size: 0.75em;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
}

.badge-danger {
    background-color: #dc3545;
    color: white;
}

.badge-warning {
    background-color: #ffc107;
    color: #212529;
}

.badge-info {
    background-color: #17a2b8;
    color: white;
}

.badge-secondary {
    background-color: #6c757d;
    color: white;
}

.badge-dark {
    background-color: #343a40;
    color: white;
}

.btn-primary {
    background-color: #FE8D18;
    border-color: #FE8D18;
    color: white;
}

.btn-primary:hover {
    background-color: #0069d9;
    border-color: #0062cc;
}

.btn-danger {
    background-color: #dc3545;
    border-color: #dc3545;
    color: white;
}

.btn-danger:hover {
    background-color: #c82333;
    border-color: #bd2130;
}

.error-row {
    cursor: pointer;
    background-color: #fff;
}

.error-row:hover {
    background-color: #f8f9fa;
}

.stacktrace {
    background-color: #f8f9fa;
    padding: 10px;
    border-radius: 4px;
    white-space: pre-wrap;
    font-family: monospace;
    font-size: 0.9em;
    margin: 5px 0;
}

.stacktrace-row {
    background-color: #f8f9fa;
}

.ml-2 {
    margin-left: 0.5rem;
}

.fa-spin {
    animation: fa-spin 1s infinite linear;
}

@keyframes fa-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/Log/Log.vue